import React, {useEffect} from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../state'
// const creatHistory = require("history").createHashHistory

// components
import styled from 'styled-components'
import { updateBakeLevel } from '../../state/bakePool/actions'
import { useBakeLevel } from '../../state/bakePool/hooks'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
const activeClassName = 'ACTIVENAV'
const ButtonItem = styled.div.attrs({
  activeClassName
})`
  position: relative;
  text-decoration: none;
  width: 100%;
  font-size: 22px;
  text-align: center;

  &.${activeClassName} {
    background: linear-gradient(to right, #FFD600, #FF7A00);
    -webkit-background-clip: text;
    color: transparent;
  }
  img{
    position: absolute;
    right: 0;
    top: -15px;
  }
  &:first-child{
    border-right: 1px solid rgba(177, 177, 177, 0.41);
  }
`
const ButtonBox = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  font-family: 'Roboto-Bold';
  width: 200px;
  margin-bottom: 15px;
`

const ExchangeBakeVersion:React.FC = ({}) => {
  const bakeLevel = useBakeLevel()
  const dispatch = useDispatch<AppDispatch>()
  const change = () => {
    dispatch(updateBakeLevel({bakeLevel: 'v1'}))
  }
  const change2 = () => {
    dispatch(updateBakeLevel({bakeLevel: 'v2'}))
  }

  // 初始化渲染
  useEffect(() => {
    dispatch(updateBakeLevel({bakeLevel: 'v2'}))
  }, [updateBakeLevel])

  return (
    <Wrapper>
        {
          location.pathname === '/exchange/pokernft' ? false : (
            <ButtonBox>
              <ButtonItem className={bakeLevel === 'v2' ? activeClassName : ''} onClick={change2}>
                V3
                <img src="/images/collection/icon_new.svg" alt=""/>
              </ButtonItem>
              <ButtonItem className={bakeLevel === 'v1' ? activeClassName : ''} onClick={change}>V2</ButtonItem>
            </ButtonBox>
          )
        }
    </Wrapper>
  )
}

export default ExchangeBakeVersion
